import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from '../contexts/LanguageContext';

const MailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const Contact: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" className="section section-alt">
      <Container>
        <Row className="justify-content-center text-center mb-5">
          <Col lg={7}>
            <p className="kicker">{t('nav.contact')}</p>
            <h2 className="section-title">{t('contact.title')}</h2>
            <p className="text-muted mb-0">{t('contact.subtitle')}</p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <div className="contact-card">
              <div className="contact-row">
                <div className="contact-icon"><MailIcon /></div>
                <div>
                  <h6>{t('contact.email')}</h6>
                  <a href="mailto:ellinorninni@gmail.com">ellinorninni@gmail.com</a>
                </div>
              </div>
              <div className="contact-row">
                <div className="contact-icon"><PhoneIcon /></div>
                <div>
                  <h6>{t('contact.spain')}</h6>
                  <a href="tel:+34664470264">+34 664 470 264</a>
                </div>
              </div>
              <div className="contact-row">
                <div className="contact-icon"><PhoneIcon /></div>
                <div>
                  <h6>{t('contact.sweden')}</h6>
                  <a href="tel:+46761883040">+46 761 883 040</a>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
